/*
 * @author: songhlc liuxu7
 * @date: 2017-10-25
 * @description: 级联列表组件
 * data:
 * selectedValue:
 * */
import template from './index.html'
import ko from 'knockout'
import {
  gridRefMixin
} from '../../mixin'
import Base from '../../core/base'
import getLang from '../../i18n'
class Cascader extends Base {
  initialize (params) {
    params.data().forEach((item) => {
      item.isLoading = ko.observable(false)
    })
    this.selectedValueIsShow = ko.observable(false)
    this.multiple = params.multiple || ko.observable(false)
    this.data = params.data
    this.selectedValue = params.selectedValue
    this.loadData = params.loadData
    this.hidden = ko.observable(true)
    this.multipleplaceholder = ko.observable(getLang('请选择'))
    gridRefMixin.call(this, params)
    // hook for ariagrid
    this.setFocus = () => {
      this.$el.querySelector('.j-handle').click()
      this.$el.querySelector('.j-handle').focus()
    }
    this.casitmevisible = ko.observable(false)
    this.casitmevisible.subscribe((val) => {
      if (val) {
        this.hidden(!val)
      } else {
        setTimeout(() => {
          this.hidden(!val)
        }, 500)
      }
    })
    this.clearable = params.clearable || false
    // 用于判断是否显示关闭按钮
    this.showCloseIcon = ko.computed(() => {
      let isClear = false
      // 选中数据有一个属性不为空就可清除
      for (let key in this.selectedValue()) {
        if (this.selectedValue()[key] !== '') {
          isClear = true
          break
        }
      }
      return this.clearable && isClear
    })
    this.handlerClear = (e) => {
      // window.event ? window.event.cancelBubble = true : e.stopPropagation()
      if (this.multiple()) {
        this.selectedValue([])
        return;
      }
      let obj = {}
      for (let key in this.selectedValue()) {
        obj[key] = ''
      }
      this.selectedValue(obj)
    }
    // this.handleVisible = () => this.casitmevisible(true)
    // this.handleClose = () => this.casitmevisible(false)
    this.handleVisible = () => {
      this.casitmevisible(true)
      this.selectedValueIsShow(false)
    }
    this.handleClose = () => {
      this.casitmevisible(false)
      this.selectedValueIsShow(false)
    }
    this.deleteSelectedItem = (rowData, e) => {
      e.stopPropagation()
      let selectedValue = this.selectedValue()
      selectedValue = selectedValue.filter(item => item.id !== rowData.id)
      this.selectedValue(selectedValue)
    }
    this.selectedValueShow = (data, e) => {
      e.stopPropagation()
      this.casitmevisible(false)
      this.selectedValueIsShow(true)
    }
    this.handleDeleteSelected = (item, e) => {
      e.stopPropagation();
      let selectedValue = this.selectedValue()
      var index = selectedValue.indexOf(item)
      selectedValue.splice(index, 1)
      this.selectedValue(selectedValue)
      window.ycloud.notice.info('删除成功', {
        timeout: 2000
      })
    }
  }
}
export default {
  name: 'cascader',
  init: Base.createViewModel(Cascader),
  template: template
}



// WEBPACK FOOTER //
// ./src/components/cascader/index.js